module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pages.total_pages > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('ul', {
    staticClass: "pagination-list"
  }, [(_vm.previousPage) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onPaginate(_vm.previousPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.texts.pagination.prev))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagesWindow), function(page) {
    return _c('li', {
      key: page,
      class: {
        active: page == _vm.pages.current_page
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.onPaginate(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), (_vm.nextPage) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onPaginate(_vm.nextPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.texts.pagination.next))]) : _vm._e()], 2), _vm._v(" "), _c('a', {
    staticClass: "show-all",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onPaginate('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.showAll))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90c9b240","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/questions/answers/pagination.vue
// module id = 208
// module chunks = 0 1 5